<template>
  <div>
    <el-row>
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline"
        style="padding-top: 0; margin-top: 0">
        <!-- <el-form-item label="客户：" v-if="currentOrderFlag == 1">
          <el-select v-model="searchForm.SUPPLIER" filterable placeholder="请选择" clearable>
            <el-option v-for="item in supplierList" :key="item.value" :label="item.AB_NAME" :value="item.SUPPLIER_ID">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="客户：">
          <el-select size="medium" filterable v-model="searchForm.TC_ID" placeholder="请选择" clearable>
            <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目点：">
          <el-select size="medium" filterable v-model="searchForm.PROJECT_ID" placeholder="请选择" clearable>
            <el-option v-for="item in points" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="周转筐：">
          <el-select size="medium" filterable v-model="searchForm.BASKET_ID" placeholder="请选择" clearable>
            <el-option v-for="item in turnoverList" :key="item.BASKET_ID" :label="item.NAME" :value="item.BASKET_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作类型：">
          <el-select size="medium" filterable v-model="searchForm.TYPE" placeholder="请选择" clearable>
            <el-option v-for="item in operationList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作日期：">
          <el-date-picker size="medium" v-model="searchForm.OPERATION_DATE" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
            clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态：" v-if="!Number(activeName)">
          <el-select size="medium" filterable v-model="searchForm.STATUS" placeholder="请选择" clearable>
            <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="medium" id="search" type="primary" @click="handleSearch">筛选</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-button size="medium" @click="openTurnoverInfoDialog(1)">添加出筐记录</el-button>
      <el-button size="medium" @click="openTurnoverInfoDialog(2)">添加回筐记录</el-button>
      <el-button size="medium" type="primary" plain @click="exportTurnoverRecords">导出记录</el-button>
      <el-button size="medium" @click="gotoTurnoverList" type="primary" style="float: right;">周转筐列表</el-button>
    </el-row>
    <el-row v-if="!Number(activeName)">
      <span style="margin-top: 10px; width: 200px; display: inline-block;">合计出筐数：{{ titleData.TOTAL_OUT_COUNT }}</span>
      <span style="width: 200px; display: inline-block;">合计回筐数：{{ titleData.TOTAL_RETURN_COUNT }}</span>
      <span style="width: 200px; display: inline-block;">合计待回筐数：{{ titleData.TOTAL_STAY_RETURN_COUNT }}</span>
    </el-row>
    <el-row>
      <el-tabs type="border-card" v-model="activeName" @tab-click="handleTabClick" style="margin-top: 20px">
        <el-tab-pane label="明细">
          <el-table :data="tableData0" stripe border>
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="TC_NAME" label="客户" min-width="200"></el-table-column>
            <el-table-column prop="PROJECT_NAME" label="项目点" min-width="150"></el-table-column>
            <el-table-column prop="OPERATE_TYPE" label="操作类型" min-width="50">
              <template slot-scope="scope">
                <span :style="{ color: scope.row.OPERATE_TYPE - 1 ? '#67C23A' : '#F56C6C' }">
                  {{ operationList[scope.row.OPERATE_TYPE - 1].label }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="BASKETS_NAME" label="筐名称" min-width="100"></el-table-column>
            <el-table-column prop="SPECIFICATION" label="规格（kg/框）" width="120"></el-table-column>
            <el-table-column label="长×宽×高（cm³）" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.LENGTH + '×' + scope.row.WIDTH + '×' + scope.row.HEIGHT }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="COLOR" label="颜色" min-width="50"></el-table-column>
            <el-table-column prop="COUNT" label="数量" min-width="40"></el-table-column>
            <el-table-column prop="USER_NAME" label="操作人" min-width="60"></el-table-column>
            <el-table-column prop="OPERATE_TIME" label="操作时间" width="160"></el-table-column>
            <el-table-column prop="STATUS" label="状态" width="160">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.OPERATE_TYPE - 1 ?
                      scope.row.STATUS ? '项目点已确认' : '项目点未确认' :
                      scope.row.STATUS ? '司机已确认' : '司机未确认'
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="60">
              <template slot-scope="scope">
                <el-button type="text" @click="modifyTurnoverRecord(scope.row)"
                  v-show="fun_dic[105090001]">修改</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="汇总">
          <el-table :data="tableData1" stripe border>
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="TC_NAME" label="客户" min-width="200"></el-table-column>
            <el-table-column prop="PROJECT_NAME" label="项目点" min-width="150"></el-table-column>
            <el-table-column prop="DATE" label="日期" min-width="100"></el-table-column>
            <el-table-column v-for="item, index in tableData1[0].LISTS" :key="item.BASKET_ID" :label="item.NAME">
              <el-table-column label="出筐" min-width="80">
                <template slot-scope="scope">
                  <span> {{ scope.row.LISTS[index].OUT_COUNT }} </span>
                </template>
              </el-table-column>
              <el-table-column label="回筐" min-width="80">
                <template slot-scope="scope">
                  <span> {{ scope.row.LISTS[index].IN_COUNT }} </span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column prop="TOTAL_OUT_COUNT" label="出筐总计" min-width="80"></el-table-column>
            <el-table-column prop="TOTAL_IN_COUNT" label="回筐总计" min-width="80"></el-table-column>
            <el-table-column prop="DIFFERENCE" label="差值" min-width="80">
              <template slot-scope="scope">
                <span
                  :style="{ color: scope.row.DIFFERENCE > 0 ? '#67C23A' : scope.row.DIFFERENCE < 0 ? '#F56C6C' : '#606266' }">
                  {{ scope.row.DIFFERENCE }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-row>
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount" style="float: right; margin-top: 20px">
      </el-pagination>
    </el-row>
    <!-- 周转筐记录模态框 -->
    <el-dialog :title="title" :visible.sync="turnoverInfoVisible" center width="400px" @close="closeTurnoverInfoDialog"
      :close-on-click-modal="false">
      <el-form size="small" :model="turnoverInfoForm" ref="turnoverInfoForm">
        <el-form-item label="客户：" :label-width="labelWidth">
          <el-select filterable v-model="turnoverInfoForm.TC_ID" placeholder="请选择" style="width: 100%;"
            @change="queryProject">
            <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目点：" :label-width="labelWidth">
          <el-select filterable v-model="turnoverInfoForm.PROJECT_ID" placeholder="请选择" style="width: 100%;">
            <el-option v-for="item in projects" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <div v-for="item in turnoverInfoForm.turnoverInfos" :key="item.key">
          <el-form-item label="周转筐：" :label-width="labelWidth" filterable>
            <el-select v-model="item.ID" placeholder="请选择周转筐" style="width: 100%;" filterable @change="turnoverChange">
              <el-option v-for="item2 in turnoverList" :label="item2.NAME" :value="item2.BASKET_ID"
                :key="item2.BASKET_ID" :disabled="item2.disabled">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数量：" :label-width="labelWidth">
            <el-input v-model.number="item.COUNT" type="number" oninput="value=value.replace(/[^0-9.]/g,'')" :min="1" placeholder="请输入数量" style="width: 100%;">
              <template slot="append">个</template>
            </el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button class="btn" @click="turnoverInfoForm.turnoverInfos.push({})"
            :disabled="disabledAdd">添加筐</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeTurnoverInfoDialog">取消</el-button>
        <el-button size="small" @click="submitTurnoverInfo" :disabled="disabledSubmit">确定</el-button>
      </div>
    </el-dialog>
    <!-- 修改周转筐记录模态框 -->
    <el-dialog title="修改" :visible.sync="modifyVisible" center width="400px" :close-on-click-modal="false">
      <el-form size="small" :model="modifyForm" ref="modifyForm">
        <el-form-item label="数量：" :label-width="labelWidth">
          <el-input v-model.number="modifyForm.COUNT" type="number" oninput="value=value.replace(/[^0-9.]/g,'')" :min="1" placeholder="请输入数量" style="width: 100%;">
            <template slot="append">个</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="modifyVisible = false">取消</el-button>
        <el-button size="small" @click="submitModifyTurnoverRecord" :disabled="disabledModify">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getActionFun } from '@/assets/api/login';
import { haveDSXMDFun, selectProjectFun, selectTCFun } from '@/assets/api/sellOrder';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      PAGE_ID: '1050900', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 105090001: 0 },
      searchForm: {},
      companys: [],
      points: [],
      turnoverList: [],
      operationList: [{ value: 1, label: '出筐' }, { value: 2, label: '回筐' }],
      statusList: [{ value: '0', label: '未确认' }, { value: '1', label: '已确认' }],
      pageSize: 10,
      currentPage: 1,
      totalCount: 0,
      tableData0: [],
      tableData1: [{}],
      titleData: {},
      title: '',
      turnoverInfoVisible: false,
      turnoverInfoForm: {
        turnoverInfos: [{}],
      },
      projects: [],
      labelWidth: '80px',
      activeName: '0',
      modifyVisible: false,
      modifyForm: {},
    };
  },
  computed: {
    disabledAdd() {
      return this.turnoverInfoForm.turnoverInfos.length >= this.turnoverList.length;
    },
    disabledSubmit() {
      return !this.turnoverInfoForm.PROJECT_ID || Boolean(this.turnoverInfoForm.turnoverInfos.find((item) => !item.ID || !item.COUNT || item.COUNT < 1));
    },
    disabledModify() {
      return Boolean(this.modifyForm.COUNT < 1) || Boolean(this.modifyForm.COUNT % 1);
    },
    TURNOVER_MANAGE_DATA_CONDITION() {
      return this.$store.state.TURNOVER_MANAGE_DATA_CONDITION;
    },
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.queryTurnoverRecords();
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTurnoverRecords();
    },
    queryTurnoverRecords() {
      const params = {
        SERVICE_ID: '10026',
        OTYPE: Number(this.activeName) ? 30 : 24,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.BASKET_ID) {
        params.BASKET_ID = this.searchForm.BASKET_ID;
      }
      if (this.searchForm.TYPE) {
        params.TYPE = this.searchForm.TYPE;
      }
      if (this.searchForm.OPERATION_DATE) {
        params.OPERATE_TIME = this.searchForm.OPERATION_DATE;
      }
      if (this.searchForm.STATUS) {
        params.STATUS = Number(this.searchForm.STATUS);
      }
      http.post(params).then((result) => {
        if (!Number(this.activeName)) {
          this.tableData0 = result.LIST;
          this.titleData = result.RESULT;
        } else {
          this.tableData1 = result.LIST;
        }
        this.totalCount = result.TOTAL_COUNT;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 拉取周转筐数据
    queryTurnover() {
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 15,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        if (result) {
          this.turnoverList = result;
          this.$store.dispatch('SET_TURNOVER_MANAGE_DATA_CONDITION', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
            ACTIVE_NAME: this.activeName,
          });
        } else {
          this.turnoverList = [];
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 获取客户列表
    queryCustomer() {
      selectTCFun().then((result) => {
        if (result.length !== 0) {
          this.companys = result[0].company;
        } else {
          this.companys = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 获取项目点列表
    loadData() {
      haveDSXMDFun().then((result) => {
        this.points = result.length > 0 ? result[0].project : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    gotoTurnoverList() {
      this.$router.push({ name: 'turnoverList' });
    },
    openTurnoverInfoDialog(flag) {
      this.title = flag == 1 ? '添加出筐记录' : '添加回筐记录';
      this.turnoverInfoForm.TYPE = flag;
      this.turnoverInfoVisible = true;
      this.queryTurnover();
    },
    closeTurnoverInfoDialog() {
      this.turnoverInfoVisible = false;
      this.turnoverInfoForm = { turnoverInfos: [{}] };
      this.projects = [];
    },
    submitTurnoverInfo() {
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 23,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PROJECT_ID: this.turnoverInfoForm.PROJECT_ID,
        BASKET_LIST: this.turnoverInfoForm.turnoverInfos,
        TYPE: this.turnoverInfoForm.TYPE,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '记录添加成功', type: 'success' });
        this.closeTurnoverInfoDialog();
        this.queryTurnoverRecords();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    turnoverChange() {
      this.turnoverList.forEach((item) => {
        item.disabled = false;
      });
      this.turnoverInfoForm.turnoverInfos.forEach((item) => {
        const temp = this.turnoverList.find((item2) => item.ID == item2.BASKET_ID);
        temp.disabled = !temp.disabled;
      });
    },
    // 选择项目点
    queryProject() {
      const params = {
        TC_ID: this.turnoverInfoForm.TC_ID,
      };
      selectProjectFun(params)
        .then((result) => {
          if (result[0]) {
            this.projects = result[0].list;
          } else {
            this.projects = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    handleTabClick(tab, event) {
      sessionStorage.setItem('returnAuditTabActiveName', this.activeName);
      this.queryTurnoverRecords();
    },
    exportTurnoverRecords() {
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 26,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.BASKET_ID) {
        params.BASKET_ID = this.searchForm.BASKET_ID;
      }
      if (this.searchForm.TYPE) {
        params.TYPE = this.searchForm.TYPE;
      }
      if (this.searchForm.OPERATION_DATE) {
        params.OPERATE_TIME = this.searchForm.OPERATION_DATE;
      }
      http.post(params).then((result) => {
        if (result[0].FILE_PATH) {
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
        this.totalCount = result.TOTAL_COUNT;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    modifyTurnoverRecord(row) {
      this.modifyForm = { ...row };
      this.modifyVisible = true;
    },
    submitModifyTurnoverRecord() {
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 28,
        ID: this.modifyForm.ID,
        COUNT: this.modifyForm.COUNT,
      };
      http.post(params)
        .then((result) => {
          this.$message.show({ text: '修改成功', type: 'success' });
          this.modifyVisible = false;
          this.queryTurnoverRecords();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (JSON.stringify(this.TURNOVER_MANAGE_DATA_CONDITION) != '{}' && this.TURNOVER_MANAGE_DATA_CONDITION != 'undefined') {
      this.searchForm = this.TURNOVER_MANAGE_DATA_CONDITION.CONDITION;
      this.currentPage = this.TURNOVER_MANAGE_DATA_CONDITION.CURRENT_PAGE;
      this.activeName = this.TURNOVER_MANAGE_DATA_CONDITION.ACTIVE_NAME;
    }
    // 获取团餐客户列表
    this.queryCustomer();
    // 获取项目点列表
    this.loadData();
    this.queryTurnover();
    this.queryTurnoverRecords();
    this.queryBeforeFun();
  },
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sortingAndDistribution/turnoverManage.vue